import cn from "classnames";
import BookForm from "components/shared/book/form";
import { Field } from "components/shared/form";
import { serializeReq } from "helpers/form";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import React from "react";
import { config, initialState } from "./config";

export class CargoOwnerShareAccess extends BookForm {
    setValue = ({ name, value }) => {
        if (this.props.controlled) {
            this.props.setValue({ name, value });
        } else {
            const isValid = this.isValidForm({ ...this.state, [name]: value });
            this.setState({ [name]: value, ...(isValid ? { isValid: true } : {}) });
        }
    };

    value = (inputName) => (this.props.controlled ? this.props.values[inputName] : this.state[inputName]);

    renderField = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <Field
                key={props.label}
                onChange={this.setValue}
                value={this.value(props.inputProps.name)}
                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                fieldWrapper="col-12"
                {...props}
                validators={[requiredField]}
            />
        );
    };

    onContactPersonChange = ({ name, value }) =>
        this.setValue({ name: "contactPerson", value: { ...this.value("contactPerson"), [name]: value } });

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, isValid, ...state } = this.state;
        const values = this.props.controlled ? this.props.values : state;
        if (!isLoading) {
            if (this.isValidForm(values)) {
                this.setState({ isLoading: true, isValid: true });
                return this.applyReq(serializeReq(values));
            }
            this.setState({ isValid: false });
        }
    };

    render() {
        const {
            kpp,
            name,
            inn,
            contactPerson: { config: contactPersonConfig },
        } = this.props.config;
        return (
            <div className={cn({ "book-form__body--invalid": !this.state.isValid, loading: this.state.isLoading })}>
                {this.renderField({ ...name, disabled: true })}
                {this.renderField({ ...inn, disabled: true })}
                {this.renderField({ ...kpp, disabled: this.value("kppDisabled") })}
                {this.renderField({
                    ...contactPersonConfig.lastName,
                    onChange: this.onContactPersonChange,
                    value: this.value("contactPerson")?.lastName,
                })}
                {this.renderField({
                    ...contactPersonConfig.firstName,
                    onChange: this.onContactPersonChange,
                    value: this.value("contactPerson")?.firstName,
                })}
                {this.renderField({
                    ...contactPersonConfig.patronymic,
                    onChange: this.onContactPersonChange,
                    value: this.value("contactPerson")?.patronymic,
                })}
                {this.renderField({
                    ...contactPersonConfig.phoneNumber,
                    onChange: this.onContactPersonChange,
                    value: this.value("contactPerson")?.phoneNumber,
                })}
                {this.renderField({
                    ...contactPersonConfig.email,
                    onChange: this.onContactPersonChange,
                    value: this.value("contactPerson")?.email,
                })}
                {!this.props.controlled && (
                    <div
                        className="btn btn-sm btn-brand btn-block"
                        onClick={(e) => {
                            this.onSubmit(e);
                            ymEvent("sharesave");
                        }}
                    >
                        Сохранить
                    </div>
                )}
            </div>
        );
    }
}

const ConfiguredForm = (props) => (
    <CargoOwnerShareAccess
        {...props}
        config={config}
        initialState={{ ...initialState, ...(props.initialState || {}) }}
    />
);

export default ConfiguredForm;
